var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41113 6.70312V12.7031M12.4111 9.70312H6.41113M9.41113 17.2031C13.5533 17.2031 16.9111 13.8453 16.9111 9.70312C16.9111 5.56099 13.5533 2.20312 9.41113 2.20312C5.269 2.20312 1.91113 5.56099 1.91113 9.70312C1.91113 13.8453 5.269 17.2031 9.41113 17.2031Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.22727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.a844a39e3d7eaa71cc73e9fac0cac7be.svg";
export { ForwardRef as ReactComponent };